import { render, staticRenderFns } from "./Group46.vue?vue&type=template&id=8318064e&scoped=true"
import script from "./Group46.vue?vue&type=script&lang=js"
export * from "./Group46.vue?vue&type=script&lang=js"
import style0 from "./Group46.vue?vue&type=style&index=0&id=8318064e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8318064e",
  null
  
)

export default component.exports